import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { consultarLogsAuditoriaService } from '../../Service/consultar-logs-auditoria.service';
import { UserService } from 'src/app/services/user.service';
declare var $:any;

@Component({
    selector: 'app-consultar-logs-auditoria',
    templateUrl: './consultar-logs-auditoria.component.html',
    styleUrls: ['./consultar-logs-auditoria.component.scss'],
    providers: [
        consultarLogsAuditoriaService
    ],
    standalone: false
})
export class ConsultarLogsAuditoriaComponent implements OnInit {
  consulAuditoriaForm: UntypedFormGroup;
  mostrarForm: UntypedFormGroup;
  fechaActual: String = new Date().toLocaleDateString('en-CA');
  documentos: any[] = [];
  totalPaginas: number = 1;
  paginaActual: number = 0;
  listaAuditoria: any[] = [];
  detalleAuditoria: any = null;
  usuario: any;
  idCliente: any;
  idUsuario: any;
  parametrizacion: boolean = false;
  transacciones: boolean = false;
  consultas: boolean = false;
  modulos: boolean = false;
  public datosTabla: boolean = false;
  public terminosCondiciones: boolean = false;
  public datosUsuario: boolean = true;
  
  constructor(private consultarLogsAuditoriaService : consultarLogsAuditoriaService,
    private formBuilder: UntypedFormBuilder,    
    private user: UserService
    ) { 
      this.consulAuditoriaForm = this.formBuilder.group({
        tipo_accion: null,
        idTipoDocIdentidad_NeoTipoDocIdentidad: null,
        numeroDocumento: null,
        fechaInicio: null,
        fechaFin: null,
        pagina: 1
      })
      this.mostrarForm = this.formBuilder.group({
        accion: null
      })
    }

  ngOnInit(){
    this.getDocumentos();    
    this.loadSelectPiker();
    this.datosUsuario = true;
    this.terminosCondiciones = false;
    this.datosTabla = false;
    this.idCliente = this.user.getUser().idCliente;
    this.idUsuario = this.user.getUser().idUsuario;
  }

  getDocumentos(){
    this.consultarLogsAuditoriaService.getTipoDocumentos().subscribe((data:any)=>{
      this.documentos = data.filter(
        (documento) => documento.personaJuridica != 1 && documento.idTipoDocIdentidad != 4 && documento.idTipoDocIdentidad != 6
      );
    })
  }

  loadSelectPiker() {
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    });
  }

  consultaAuditoria(){
    if(this.consulAuditoriaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value!=null){
      this.consulAuditoriaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
      .setValue(Number(this.consulAuditoriaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value));
    }
    if(this.consulAuditoriaForm.get('numeroDocumento').value==''){
      this.consulAuditoriaForm.get('numeroDocumento').setValue(null);
    } 
    const body:any ={
      fechaFinal: this.consulAuditoriaForm.get('fechaFin').value,
      fechaInicial: this.consulAuditoriaForm.get('fechaInicio').value,
      idTipoDocIdentidad: this.consulAuditoriaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value,
      numeroDocumento: this.consulAuditoriaForm.get('numeroDocumento').value,
      idCliente: Number(this.idCliente),
      idUsuario: Number(this.idUsuario),
      pagina: this.consulAuditoriaForm.get('pagina').value
    }
    if(this.consulAuditoriaForm.get('tipo_accion').value!=null){
      switch (this.consulAuditoriaForm.get('tipo_accion').value) {
        case 'CONSULTAS':
          this.consultarLogsAuditoriaService.auditoriaConsultas(body).subscribe((response:any)=>{
            this.terminosCondiciones = false;
            this.listaAuditoria = response.data;
            this.consultas = true;
            this.validarLista(response);
          })
          break;
        case 'MÓDULOS':
          this.consultarLogsAuditoriaService.auditoriaModulos(body).subscribe((response:any)=>{
            this.terminosCondiciones = false;
            this.listaAuditoria = response.data;
            this.modulos = true;
            this.validarLista(response);            
          })
          break;
        case 'PARAMETRIZACIÓN':
          this.consultarLogsAuditoriaService.auditoriaParametrizacion(body).subscribe((response:any)=>{
            this.terminosCondiciones = false;
            this.listaAuditoria = response.data;
            this.parametrizacion = true;
            this.validarLista(response);
          })
          break;
        case 'TRANSACCIONES':
          this.consultarLogsAuditoriaService.auditoriaTransacciones(body).subscribe((response:any)=>{
            this.terminosCondiciones = false;
            this.listaAuditoria = response.data;
            this.transacciones = true;
            this.validarLista(response);
          })
          break;       
        default:
          console.log('NO ELIGIO NINGUNA OPCIÓN');
      }      
    }
  }

  validarLista(response){
    if(this.listaAuditoria==undefined){
      this.datosTabla = false;
      this.mensaje();
    }else{
      this.datosTabla = true; 
      this.totalPaginas = response.paginasTotales;
      this.paginaActual = response.paginaActual;       
    }   
  }

  mensaje(){
    $('#mensajeModal').modal('show');    
  }

  verDetalle(i){
    this.usuario = this.listaAuditoria[i].idAuditoria;    
    this.mostrarForm.get('accion').setValue(this.consulAuditoriaForm.get('tipo_accion').value);
    switch (this.consulAuditoriaForm.get('tipo_accion').value) {      
      case 'CONSULTAS':
        this.consultarLogsAuditoriaService.getAuditoriaConsultas(this.usuario).subscribe((response:any)=>{
          this.validarDetalle(response);
        })
        break;
      case 'MÓDULOS':
        this.consultarLogsAuditoriaService.getAuditoriaModulos(this.usuario).subscribe((response:any)=>{
          this.validarDetalle(response);            
        })
        break;
      case 'PARAMETRIZACIÓN':
        this.consultarLogsAuditoriaService.getAuditoriaParametrizacion(this.usuario).subscribe((response:any)=>{
          this.validarDetalle(response);          
        })
        break;
      case 'TRANSACCIONES':
        this.consultarLogsAuditoriaService.getAuditoriaTransacciones(this.usuario).subscribe((response:any)=>{
          this.validarDetalle(response);
        })
        break;
      default:
        console.log('NO ELIGIO NINGUNA OPCIÓN');
    }
  }

  validarDetalle(response){
    if((response == undefined) && (response == null)){  
      $('#mensajeNoSeEncontro').modal('show');
    }else{
      this.detalleAuditoria = response;
      this.datosUsuario = false;
    }
  }
  
  descargar(isExcel){
    const body:any ={
      fechaFinal: this.consulAuditoriaForm.get('fechaFin').value,
      fechaInicial: this.consulAuditoriaForm.get('fechaInicio').value,
      idTipoDocIdentidad: this.consulAuditoriaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value,
      numeroDocumento: this.consulAuditoriaForm.get('numeroDocumento').value,
      idCliente: Number(this.idCliente),
      idUsuario: Number(this.idUsuario),
      transacciones: this.transacciones,
      consultas: this.consultas,
      modulos: this.modulos,
      parametrizacion: this.parametrizacion,
      isExcel: isExcel,
      pagina: this.consulAuditoriaForm.get('pagina').value
    }
    this.consultarLogsAuditoriaService.descargaArchivoAudi(body).subscribe((response:any)=>{
      if(response.exitoso == true){
        var a = document.getElementById('downloadFile');
        a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
        a.setAttribute('download', unescape(response.fileName));
        a.click();
      }    
    })
  }

  selectPage(pageNumber: number){
    this.consulAuditoriaForm.get('pagina').setValue(pageNumber);
    this.consultaAuditoria();
  }
  
  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (this.consulAuditoriaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 5 ||
    this.consulAuditoriaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 3) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.consulAuditoriaForm.get('numeroDocumento').setValue('');
  }

  validateField(key: string) {
    return (
        (this.consulAuditoriaForm.get(key).dirty ||
            this.consulAuditoriaForm.get(key)?.touched) &&
        this.consulAuditoriaForm.get(key)?.invalid
    );
  } 

}
